
import React, {FC, useEffect} from 'react';
import {GatsbyImage, IGatsbyImageData} from 'gatsby-plugin-image';
import moment from 'moment-timezone';
import SimpleBar from 'simplebar';
import {ContentProps} from 'templates/blog/post/Content';

import {Content} from './Content';

import 'simplebar/dist/simplebar.css';
import * as styles from './styles.module.scss';

interface PostProps {
	title: string
	image: {
		alt: string
		image: IGatsbyImageData
	};
	author: {
		name: string
	};
	minutes: number
	published: string
	content: ContentProps
}

const Post: FC<PostProps> = (props) => {
	const published = moment(props.published).format('MMM D, YYYY');
	useEffect(() => {
		const tables = document.getElementsByClassName(styles.contentTable);
		for (const tbl of tables) {
			new SimpleBar(tbl as HTMLElement, {
				autoHide: false,
				forceVisible: 'x',
			});
		}
	}, []);
	return (
		<div className={styles.post}>

			<div className={styles.heading}>
				<h1 className={styles.title}>{props.title}</h1>
				<div className={styles.byline}>
					{props.minutes} MIN READ • BY {props.author.name} • {published}
				</div>
			</div>

			<GatsbyImage
				className={styles.image}
				{...props.image}
			/>

			<Content
				classNames={{
					wrapper: styles.content,
					image: styles.contentImage,
					table: styles.contentTable,
				}}
				{...props.content}
			/>
		</div>
	);
};

export default Post;
